import { InvoiceWccDto, CreateInvoiceWccDto, UpdateWccDto, WccDto } from '@sr/dto';
import { plainToInstance } from 'class-transformer';
import { authorizedRequest } from 'shared/api/axios';
import { INVOICES_BASE_URL, WCC_BASE_URL } from 'shared/api/api';

export const fetchInvoiceWcc = async (invoiceId: number) => {
  const result = await authorizedRequest<void, InvoiceWccDto>(
    `${INVOICES_BASE_URL}/wcc/${invoiceId}`,
    'GET');
  return plainToInstance(InvoiceWccDto, result, { enableImplicitConversion: true });
};

export const postInvoiceWcc = async (dto: CreateInvoiceWccDto) => {
  return await authorizedRequest<CreateInvoiceWccDto, InvoiceWccDto>(
    `${INVOICES_BASE_URL}/wcc/`,
    'POST',
    dto
  );
};

export const deleteInvoiceWcc = async (invoiceId: number) => {
  return await authorizedRequest<void, void>(
    `${INVOICES_BASE_URL}/wcc/${invoiceId}`,
    'DELETE'
  );
};

export const fetchWcc = async (id: number) => {
  const result = await authorizedRequest<void, WccDto>(
    `${WCC_BASE_URL}/${id}`,
    'GET');
  return result;
};

export const fetchUpdateWcc = async (dto: UpdateWccDto) => {
  const result = await authorizedRequest<UpdateWccDto, WccDto>(
    `${WCC_BASE_URL}`,
    'PUT',
    dto
  );
  return plainToInstance(WccDto, result, { enableImplicitConversion: true });
};
